import {createSlice, PayloadAction, SliceCaseReducers} from "@reduxjs/toolkit";
import {resetPassword} from "../service/reset-password/reset-password-state";


interface ResetPasswordState {
    status: 'idle' | 'pending' | 'fulfilled' | 'rejected';
    password: string;
    retypePassword: string;
    token: string;
    loading: boolean;
    errors: Record<string, string>;
    error: string,
    message:string,
    success:boolean
}

const initialState: ResetPasswordState = {
    status: 'idle',
    password: "",
    retypePassword: '',
    token: '',
    loading: false,
    errors: {},
    error: '',
    message: '',
    success:false
};


const resetPasswordSlice = createSlice<ResetPasswordState, SliceCaseReducers<ResetPasswordState>>({
    name: 'passwordReset',
    initialState,
    reducers: {
        setPassword: (state, action: PayloadAction<string>) => {
            state.password = action.payload;
        },
        setRetypePassword: (state, action: PayloadAction<string>) => {
            state.retypePassword = action.payload;
        },
        setToken: (state, action: PayloadAction<string>) => {
            state.token = action.payload;
        },
        setPasswordData: (state, action: PayloadAction<Partial<ResetPasswordState>>) => {
            Object.assign(state, action.payload);
        },
    },
    extraReducers: (builder) => {
        builder.addCase(resetPassword.pending, (state) => {
            state.status = 'pending';
            state.loading = true;
        });

        builder.addCase(
            resetPassword.fulfilled,
            (state, action: any) => {
                state.status = action.payload.success ? "fulfilled" : "rejected";
                state.loading = false;
            }
        );

        builder.addCase(resetPassword.rejected, (state,action: any) => {
            state.status = action.payload.success ? "rejected" : "fulfilled";
            state.loading = false;
            state.errors = { ...state.errors, ...action.payload };
        });
    },
});

export const {actions: resetPasswordActions} = resetPasswordSlice;

export const resetPasswordReducer = resetPasswordSlice.reducer;